// extracted by mini-css-extract-plugin
export default {"unsubscribePage":"Gbc833d G47a047"};